import * as React from 'react';
import "./Header.scss";
import { HeaderProps } from './IHeader';

const Header = (props: HeaderProps) => {
  return (
    <div
      className="header"
      style={{
        borderTopLeftRadius: props.borderRadius,
        borderTopRightRadius: props.borderRadius
      }}
    >
      <div className="contents" style={{
          height: props.height,
        }}
        dangerouslySetInnerHTML={{
          __html: props.text
        }
      }></div>
      {props.children}
    </div>
  )
}

export default Header;